<!-- src/App.vue -->
<template>
  <div id="app">
    <div class="mobile-wrapper">
      <router-view />
    </div>
  </div>
</template>

<style scoped>
/* Wrapper to enforce mobile width on all devices */
.mobile-wrapper {
  max-width: 375px; /* Cap at 375px for larger screens */
  width: 100%; /* Allow it to shrink for smaller screens */
  margin: 0 auto; /* Center on larger screens */
  background-color: white; /* Match the page background */
  min-height: 100vh; /* Ensure it takes full height */
  position: relative;
  overflow-x: hidden; /* Prevent horizontal overflow */
}
</style>

<style>
#app {
  font-family: "Vazir"; /* Use Vazir font globally */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #00ffcc;
  display: block;
}
</style>
